import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Drawer } from '@uhg-abyss/web/ui/Drawer';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import { RadioGroup } from '@uhg-abyss/web/ui/RadioGroup';
import { Text } from '@uhg-abyss/web/ui/Text';

export const StyledChoosePCPAlertGroup = styled(Layout.Group, {
  '&.abyss-layout-group': {
    justifyContent: 'space-between !important',
  },
});

export const StyledChoosePCPAlertIcon = styled(IconSymbol, {
  marginRight: '4px',
});

export const StyledChoosePCPAlertClose = styled(IconSymbol, {
  cursor: 'pointer',
});

export const StyledChoosePCPAlertModalRadioGroup = styled(RadioGroup, {
  '&.abyss-radio-group-root': {
    border: 'none',
  },
});

export const StyledChoosePCPAlertModalGroup = styled(Layout.Group, {
  cursor: 'pointer',
  marginBottom: '24px',

  '.abyss-radio-label': {
    padding: '0',
  },

  '&:last-of-type': {
    marginBottom: '0',
  },

  '@media (max-width: 464px)': {
    lineHeight: '20px',
  },
});

export const StyledChoosePCPAlertModal = styled(ModalDialog, {
  '&.abyss-modal-base-content-container': {
    width: '558px',
    borderRadius: '12px',
    padding: '15px',
  },

  '&.abyss-modal-base-body': {
    padding: '$sm',
  },

  '&.abyss-modal-close-button': {
    margin: '$md',
  },
});

export const StyledChoosePCPAlertModalTitle = styled(Text, {
  '&.abyss-text-root': {
    fontSize: '25.63px',
    fontWeight: 'bold',
    lineHeight: '32px',
  },
});

export const StyledChoosePCPAlertModalSection = styled('div', {
  maxHeight: '199px',
  overflow: 'auto',
  paddingBottom: '0',
});

export const StyledChoosePCPAlertModalButtonRow = styled('div', {
  marginTop: '10px',
});

export const StyledChoosePCPAlertDrawerContainer = styled(Drawer, {
  '&.abyss-modal-base-content-container': {
    borderRadius: '20px 20px 0 0',
    height: 'inherit',
  },
  '&.abyss-modal-base-body': {
    padding: '16px',
  },
});

export const StyledChoosePCPAlertDrawerTitleContainer = styled('div', {
  marginBottom: '26px',
});

export const StyledChoosePCPAlertDrawerTitle = styled(Text, {
  '&.abyss-text-root': {
    fontSize: '20.25px',
  },
});

export const StyledChoosePCPAlertDrawerSection = styled('div', {
  maxHeight: '172px',
  overflowY: 'auto',
  overflowX: 'hidden',
});

export const StyledChoosePCPAlertDrawerButtonRow = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  marginTop: '28px',
});

export const StyledChoosePCPAlertDrawerButton = styled(Button, {
  width: '100%',
});
